import { render, staticRenderFns } from "./approval-steps.vue?vue&type=template&id=27711fd8&scoped=true&"
import script from "./approval-steps.vue?vue&type=script&lang=js&"
export * from "./approval-steps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27711fd8",
  null
  
)

export default component.exports